module.exports = __webpack_public_path__ + "img/gallery-3.8579d64c.jpg";